import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  const scrollToPricing = () => {
    const priceSection = document.getElementById('price-section');
    if (priceSection) {
      priceSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative w-full min-h-screen bg-gradient-to-br from-emerald-primary via-emerald-secondary to-emerald-primary overflow-hidden" data-id="element-26">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-27">
        <div className="absolute top-20 left-10 w-64 h-64 bg-gold-primary rounded-full blur-3xl" data-id="element-28"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-gold-light rounded-full blur-3xl" data-id="element-29"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-24 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 min-h-screen" data-id="element-30">
        {/* Text Content */}
        <motion.div className="flex-1 text-center lg:text-left" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-31">
          <motion.h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gold-primary mb-6 leading-tight" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-32">
            Dejar de ganar en Pesos es una decisión, no un milagro.
          </motion.h1>

          <motion.p className="text-xl md:text-2xl text-cream-primary mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-33">
            Aprende la habilidad que permite a las mujeres colombianas capturar
            el mercado de dólares trabajando desde un celular.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-34">
            <CTAButton size="large" onClick={scrollToPricing} data-id="element-35">
              Quiero Ganar en Dólares
            </CTAButton>
          </motion.div>
        </motion.div>

        {/* Hero Image */}
        <motion.div className="flex-1 w-full max-w-lg lg:max-w-xl" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.3
      }} data-id="element-36">
          <img src="https://cdn.magicpatterns.com/uploads/fPC1MG7DuFJQMBJWFZzJRY/Master_Setter_imagen.png" alt="Máster Setter - Dispositivos mostrando el programa de capacitación" className="w-full h-auto drop-shadow-2xl" data-id="element-37" />
        </motion.div>
      </div>
    </section>;
}